// Simple configuration for the root path
// Change this to control where "home" navigation goes
export const ROOT_PATH = import.meta.env.VITE_ROOT_PATH || '/landing' 